import postTabularMultihubView from './postTabularMultihubComponent.html';
import './postTabularMultihubComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager.js';

export function postTabularMultihubComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postTabularMultihubComponentCtrl,
		template: postTabularMultihubView,
	};
}

export class postTabularMultihubComponentCtrl {
	constructor(modal) {
		'ngInject';
		this.modal = modal;
		AssetManager.loadBubbleCss(this.post);
	}

	showDetails(post) {
		this.modal.iframe(`/hub#/post/${post.id}/detail`, {
			width: 'full',
			height: 'full',
			heading: post.headline,
		});
	}
}
